import { useEffect } from 'react';
import { NavigationType } from 'react-router-dom';

const excludePaths = ['/l/', '/locals/', '/become-a-host/'];

type ScrollToTopProps = {
  newLocation?: any;
  navigationType: NavigationType;
  isModal: boolean;
};

const ScrollToTop = ({
  newLocation,
  navigationType,
  isModal,
}: ScrollToTopProps) => {
  useEffect(() => {
    const exclude = excludePaths.some((path) =>
      newLocation?.pathname.includes(path),
    );
    if (!isModal && navigationType === NavigationType.Push && !exclude) {
      window.scrollTo(0, 0);
    }
  }, [newLocation, isModal, navigationType]);

  return null;
};

export default ScrollToTop;
